import React, { useState } from 'react';
import { FormControl, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "../FormControl/Style.css";
const FormControlSelect = ({ value, handleChange, dataList, placeholder }) => {
    const [open, setOpen] = useState(false);
    const handleCheckboxChange = (item) => {
        const currentIndex = value.indexOf(item);
        const newChecked = [...value];
        if (currentIndex === -1) {
            newChecked.push(item); 
        } else {
            newChecked.splice(currentIndex, 1);
        }
        handleChange(newChecked);
    };
    const itemStyle = {
        fontFamily: 'Inter',
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: '16.94px',
        textAlign: 'left',
    };
    return (
        <FormControl
            className="fc-select-cal"
            sx={{ m: 1, minWidth: 200 }}
        >
            <div className="select-main">
                <Select
                    className="form-cntl-select"
                    multiple
                    open={open}
                    onClose={() => setOpen(false)}
                    onOpen={() => setOpen(true)}
                    value={value}
                    displayEmpty
                    IconComponent={KeyboardArrowDownIcon}
                    inputProps={{ 'aria-label': 'Without label' }}
                    renderValue={() => (
                        <div style={{ display: 'grid' }}>
                            <em className='placeholder-filters'>{placeholder}</em>
                           
                                {value.length > 0 ?  <span className='select-filter-fc' style={{color:"#DA291C"}}>{value.length} selected </span>: <span className='select-filter-fc'>Select</span>}
                            
                        </div>
                    )}
                    sx={{
                        '.MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                    }}
                >
                    <div className="map-event">
                        {dataList.map((item, index) => (
                            <MenuItem
                                key={index}
                                value={item}
                                onClick={() => handleCheckboxChange(item)}
                                className="full-event"
                                sx={itemStyle}
                            >
                                <Checkbox
                                    className='checkbox-cal-filters'
                                    checked={value.indexOf(item) > -1} 
                                />
                                <ListItemText
                                    primary={item}
                                    primaryTypographyProps={{ sx: itemStyle }}
                                />
                            </MenuItem>
                        ))}
                    </div>
                </Select>
            </div>
        </FormControl>
    );
};
export default FormControlSelect;